import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Redirect} from 'react-router';

import {Link} from 'components/ReactRouterDomLocalized';

import {login} from 'backend-helpers/member';

import {t} from 'l10n';

import {LOGIN_SUCCESS} from 'reducers/currentUser';

// todo: make 'form' Node module
import {Form, InputWrapper, ErrorContainer} from 'form';

class ModalMenuLoginForm extends Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.onLoginSuccess = this.onLoginSuccess.bind(this);
    }

    onSubmit(formData, setErrors) {
        login(formData).then(this.onLoginSuccess).catch(function(error) {
            //console.log('ModalMenuLoginForm onError', error);

            if (typeof error === 'string') {
                setErrors(error);
            } else {
                if(error.message !== "Network Error")
                    setErrors(t(error.message));
                else 
                    setErrors(t('Unknown Error'));
            }
        });
    }

    onLoginSuccess({user, token}) {
        let {dispatch} = this.props;

        // todo: make an action creator?
        // todo: move redirect logic to middleware?

        dispatch({type: LOGIN_SUCCESS, user, token});
        if (this.props.onLogin) {
            this.props.onLogin();
        }
    }

    render() {
        let { currentUser } = this.props;

        return (
            <div>
                <p className="name">
                    <span>{t('Log in')}</span>
                    {currentUser.exists() && !currentUser.isActive()
                        ? <Link to="/?confirm_registration" className="header-button">{t('Activate')}</Link>
                        : <Link to="/?register" className="header-button">{t('Sign up')}</Link>
                    }
                </p>
                <Form onSubmit={this.onSubmit}>
                    <ErrorContainer data-errorcontainer={true} />

                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="nick" type="text" placeholder={t('Nick')}/>
                    </div>
                    <div>
                        <InputWrapper data-formfield={true} name="password" type="password" placeholder={t('Password')}/>
                    </div>
                    <div>
                        <div className="right-text">
                            <Link to="/?password_recover" className="header-button">{t('Forgot password?')}</Link>
                        </div>
                    </div>
                    <div>
                        <button type='submit' className="btn-submit">{t('Enter')}</button>
                    </div>
                </Form>
            </div>
        )
    }
}

export default connect()(ModalMenuLoginForm);


// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuLoginForm.js